import { useContext } from "react"
import { AuthContext } from "../../context/AuthContext.js"

//Importing Components
import Topbar from "../../components/topbar/Topbar.jsx"
import Sidebar from "../../components/sidebar/Sidebar.jsx"
import Saved from "../../components/saved/SavedPosts.jsx"
import Rightbar from "../../components/rightbar/Rightbar.jsx"

//Importing stylesheet
import './saved.css'


const Home = () => {
    const {user} = useContext(AuthContext)
    return (
        <>
            <Topbar/>
            <div className="homeContainer">
                <Sidebar /> 
                <Saved />
                <Rightbar user={user} localisation="home"/> 
            </div>
        </>
    )
}

export default Home
